<div class="insight-container">
    <div class="report-menu">
      <div class="report-title-with-actions">
        <div class="report-name">
          Device Report
        </div>

        <div class="report-menu__actions">
          <button
            mat-icon-button
            [matMenuTriggerFor]="downloadMenu"
            [disabled]="isLoading"
            class="report-button"
            [matTooltip]="'Download'"
          >
            <mat-icon>download_for_offline</mat-icon>
          </button>
          <mat-menu #downloadMenu="matMenu">
            <button
              mat-menu-item
              (click)="loadCSVExportFile()"
            >
              CSV
            </button>
          </mat-menu>

          <button mat-icon-button
                  (click)="showSettingsDialog()"
                  class="caption text-primary report-button"
                  matTooltip="Configure visible columns"
          >
            <mat-icon>settings</mat-icon>
          </button>

          <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                             [active]="showingFilterBar"
                             (toggled)="toggleFilter()"
          ></app-filter-button>

          <button
            mat-icon-button
            (click)="closeInsight()"
            [matTooltip]="'Close'"
            class="report-button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="report-subtitle">
        See devices information
      </div>
    </div>

    <app-filter-bar
      class="report-menu__filters"
      [origin]="'deviceReport'"
      [showingFilterBar]="showingFilterBar"
      [useDateFilter]="true"
      (dateFilterChanged)="dateFilterChanged($event)"
      (textFiltersChanged)="textFiltersChanged($event)"
      (appliedFiltersChanged)="appliedFiltersCount = $event"
    >
      <app-text-search-composite [title]="'Phone'" [id]="'phone'"></app-text-search-composite>
      <app-text-search-composite [title]="'IMEI'" [id]="'imei'"></app-text-search-composite>
      <app-text-search-composite [title]="'S/N'" [id]="'sn'"></app-text-search-composite>
    </app-filter-bar>

    <div class="report__table__wrapper"
         [ngClass]="{'report-table-with-filter-bar': showingFilterBar}"
    >
        <app-device-report-table
                [configuration]="configuration"
                [columns]="columns"
                [dataSource]="dataSource"
                (sortChangedEvent)="loadReport()"
                (scrolledToBottomEvent)="extendReport()"
        >
        </app-device-report-table>
    </div>
</div>
